function normalizeAddress(address) {
  if (!address) {
    return {
      line1: '',
      line2: '',
      city: '',
      state: '',
      postcode: '',
      country: 'US',
    };
  }

  if (typeof address === 'string') {
    return {
      line1: address,
      line2: '',
      city: '',
      state: '',
      postcode: '',
      country: 'US',
    };
  }

  return {
    line1: address.line1 || address.address1 || address.street || '',
    line2: address.line2 || address.address2 || '',
    city: address.city || '',
    state: address.state || address.province || '',
    postcode: address.postcode || address.zip || address.postal_code || '',
    country: address.country || 'US',
  };
}

export function boutiqueToCartAttributes(boutique, eta = '') {
  if (!boutique) return {};

  const address = normalizeAddress(boutique.address);

  return {
    'store-id': String(boutique.id ?? ''),
    'store-name': boutique.name || '',
    'store-first-name': boutique.firstName || '',
    'store-last-name': boutique.lastName || '',
    'store-address1': address.line1,
    'store-address2': address.line2,
    'store-city': address.city,
    'store-state': address.state,
    'store-postcode': address.postcode,
    'store-country': address.country,
    'store-phone': boutique.phone || '',
    'store-openhours': boutique.openHours || '',
    'store-url': boutique.url || '',
    'store-lat': boutique.lat != null ? String(boutique.lat) : '',
    'store-lng': boutique.lng != null ? String(boutique.lng) : '',
    'store-pickup-eta': eta || boutique.etaFormatted || boutique.eta || '',
  };
}

export function emptyCartAttributes() {
  return {
    'store-id': '',
    'store-name': '',
    'store-first-name': '',
    'store-last-name': '',
    'store-address1': '',
    'store-address2': '',
    'store-city': '',
    'store-state': '',
    'store-postcode': '',
    'store-country': '',
    'store-phone': '',
    'store-openhours': '',
    'store-url': '',
    'store-lat': '',
    'store-lng': '',
    'store-pickup-eta': '',
  };
}

export function clickCollectLineItemProperties(boutique) {
  return {
    _delivery_method: 'click and collect',
    _boutique_id: String(boutique?.id ?? ''),
    _boutique_name: boutique?.name || '',
  };
}

export function deliveryLineItemProperties() {
  return {
    _delivery_method: 'delivery',
    _boutique_id: '',
    _boutique_name: '',
  };
}
